import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import { createApp } from "vue";
import App from "./App.vue";
import card from "./Component/Card.vue";
import changerouter from "./Component/ChangeRouter";
import router from "./router";
import store from "./store";


let app = createApp(App);
app.component("card-part", card);
app.component("changerouter-part", changerouter);
app.use(store);
app.use(router);
router.isReady().then(function() {
  app.mount("#app");
});
